module.exports = __webpack_public_path__ + "static/media/polytope_52_5_52_layers_4_4.c39ac41f.gif";